import React from 'react'
import { CacheProvider } from '@emotion/react'
import { cacheRtl } from './src/theme'
import './src/styles/accessibility.css'

// Wrap root element to ensure Emotion cache is available during hydration
export const wrapRootElement = ({ element }) => {
  // In browser, create cache with insertion point to prevent FOUC
  const cache = cacheRtl()
  return <CacheProvider value={cache}>{element}</CacheProvider>
}
